// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file modules/apiengine/services/companies/companies.proto (package aurora.core.apiengine.companiesv1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { PbCompanyInfo } from "../../../../common/protos/types_pb";
import { file_common_protos_types } from "../../../../common/protos/types_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file modules/apiengine/services/companies/companies.proto.
 */
export const file_modules_apiengine_services_companies_companies: GenFile = /*@__PURE__*/
  fileDesc("CjRtb2R1bGVzL2FwaWVuZ2luZS9zZXJ2aWNlcy9jb21wYW5pZXMvY29tcGFuaWVzLnByb3RvEiFhdXJvcmEuY29yZS5hcGllbmdpbmUuY29tcGFuaWVzdjEiFgoUTGlzdENvbXBhbmllc1JlcXVlc3QiVgoVTGlzdENvbXBhbmllc1Jlc3BvbnNlEj0KCWNvbXBhbmllcxgBIAMoCzIqLmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5jb21wYW5pZXN2MS5Db21wYW55IiMKB0NvbXBhbnkSCgoCaWQYASABKAkSDAoEbmFtZRgCIAEoCSIbChlMaXN0Q29tcGFueURldGFpbHNSZXF1ZXN0IlkKGkxpc3RDb21wYW55RGV0YWlsc1Jlc3BvbnNlEjsKCWNvbXBhbmllcxgBIAMoCzIoLmF1cm9yYS5jb3JlLmNvbW1vbi5wcm90b3MuUGJDb21wYW55SW5mbzKtAgoOQ29tcGFueVNlcnZpY2UShAEKDUxpc3RDb21wYW5pZXMSNy5hdXJvcmEuY29yZS5hcGllbmdpbmUuY29tcGFuaWVzdjEuTGlzdENvbXBhbmllc1JlcXVlc3QaOC5hdXJvcmEuY29yZS5hcGllbmdpbmUuY29tcGFuaWVzdjEuTGlzdENvbXBhbmllc1Jlc3BvbnNlIgASkwEKEkxpc3RDb21wYW55RGV0YWlscxI8LmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5jb21wYW5pZXN2MS5MaXN0Q29tcGFueURldGFpbHNSZXF1ZXN0Gj0uYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbXBhbmllc3YxLkxpc3RDb21wYW55RGV0YWlsc1Jlc3BvbnNlIgBCRFpCZ2l0bGFiLnBydmJsLmNvbS9hdXJvcmEvY29yZS9zcmMvbW9kdWxlcy9hcGllbmdpbmUvYXBpL2NvbXBhbmllc3YxYgZwcm90bzM", [file_common_protos_types]);

/**
 * @generated from message aurora.core.apiengine.companiesv1.ListCompaniesRequest
 */
export type ListCompaniesRequest = Message<"aurora.core.apiengine.companiesv1.ListCompaniesRequest"> & {
};

/**
 * Describes the message aurora.core.apiengine.companiesv1.ListCompaniesRequest.
 * Use `create(ListCompaniesRequestSchema)` to create a new message.
 */
export const ListCompaniesRequestSchema: GenMessage<ListCompaniesRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_companies_companies, 0);

/**
 * @generated from message aurora.core.apiengine.companiesv1.ListCompaniesResponse
 */
export type ListCompaniesResponse = Message<"aurora.core.apiengine.companiesv1.ListCompaniesResponse"> & {
  /**
   * @generated from field: repeated aurora.core.apiengine.companiesv1.Company companies = 1;
   */
  companies: Company[];
};

/**
 * Describes the message aurora.core.apiengine.companiesv1.ListCompaniesResponse.
 * Use `create(ListCompaniesResponseSchema)` to create a new message.
 */
export const ListCompaniesResponseSchema: GenMessage<ListCompaniesResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_companies_companies, 1);

/**
 * @generated from message aurora.core.apiengine.companiesv1.Company
 */
export type Company = Message<"aurora.core.apiengine.companiesv1.Company"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message aurora.core.apiengine.companiesv1.Company.
 * Use `create(CompanySchema)` to create a new message.
 */
export const CompanySchema: GenMessage<Company> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_companies_companies, 2);

/**
 * @generated from message aurora.core.apiengine.companiesv1.ListCompanyDetailsRequest
 */
export type ListCompanyDetailsRequest = Message<"aurora.core.apiengine.companiesv1.ListCompanyDetailsRequest"> & {
};

/**
 * Describes the message aurora.core.apiengine.companiesv1.ListCompanyDetailsRequest.
 * Use `create(ListCompanyDetailsRequestSchema)` to create a new message.
 */
export const ListCompanyDetailsRequestSchema: GenMessage<ListCompanyDetailsRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_companies_companies, 3);

/**
 * @generated from message aurora.core.apiengine.companiesv1.ListCompanyDetailsResponse
 */
export type ListCompanyDetailsResponse = Message<"aurora.core.apiengine.companiesv1.ListCompanyDetailsResponse"> & {
  /**
   * @generated from field: repeated aurora.core.common.protos.PbCompanyInfo companies = 1;
   */
  companies: PbCompanyInfo[];
};

/**
 * Describes the message aurora.core.apiengine.companiesv1.ListCompanyDetailsResponse.
 * Use `create(ListCompanyDetailsResponseSchema)` to create a new message.
 */
export const ListCompanyDetailsResponseSchema: GenMessage<ListCompanyDetailsResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_companies_companies, 4);

/**
 * Methods to query companies
 *
 * @generated from service aurora.core.apiengine.companiesv1.CompanyService
 */
export const CompanyService: GenService<{
  /**
   * List available companies
   *
   * @generated from rpc aurora.core.apiengine.companiesv1.CompanyService.ListCompanies
   */
  listCompanies: {
    methodKind: "unary";
    input: typeof ListCompaniesRequestSchema;
    output: typeof ListCompaniesResponseSchema;
  },
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from rpc aurora.core.apiengine.companiesv1.CompanyService.ListCompanyDetails
   */
  listCompanyDetails: {
    methodKind: "unary";
    input: typeof ListCompanyDetailsRequestSchema;
    output: typeof ListCompanyDetailsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_modules_apiengine_services_companies_companies, 0);

